<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_6969_24055)">
      <path
        d="M15 19H5M15 19L15.803 19C16.921 19 17.48 19 17.907 18.782C18.284 18.59 18.59 18.284 18.782 17.908C19 17.481 19 16.921 19 15.803L19 7.22C19 6.77 19 6.545 18.952 6.331C18.9094 6.14009 18.8389 5.95647 18.743 5.786C18.637 5.596 18.487 5.431 18.193 5.104L15.438 2.042C15.097 1.664 14.924 1.472 14.717 1.334C14.5303 1.21013 14.3241 1.11853 14.107 1.063C13.863 1 13.6 1 13.075 1L4.2 1C3.08 1 2.52 1 2.092 1.218C1.71569 1.40974 1.40974 1.71569 1.218 2.092C1 2.52 1 3.08 1 4.2L1 15.8C1 16.92 1 17.48 1.218 17.907C1.41 18.284 1.715 18.59 2.092 18.782C2.519 19 3.079 19 4.197 19H5M15 19V15.197C15 14.079 15 13.519 14.782 13.092C14.59 12.7155 14.2837 12.4096 13.907 12.218C13.48 12 12.92 12 11.8 12L8.2 12C7.08 12 6.52 12 6.092 12.218C5.71569 12.4097 5.40974 12.7157 5.218 13.092C5 13.52 5 14.08 5 15.2V19M13 5L7 5"
        stroke="#9CA3AF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6969_24055">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
